import * as moment from "moment";
import "moment/locale/pt-br";

export function getDataAtual() {
  let data = new Date();
  if (moment(new Date()).format("Z") == "-02:00") {
    data.setHours(data.getHours() - 1);
  }

  return moment(data).format("YYYY/MM/DD HH:mm:ss");
}

export function getData(data) {
  data = new Date(data);
  if (moment(new Date()).format("Z") == "-03:00") {
    data.setHours(data.getHours() + 1);
  }

  return data;
}

export function getDataHoraFormatada(data, formato = "YYYY/MM/DD HH:mm:ss") {
  data = new Date(data);
  if (formato.length == 10) {
    data.setHours(data.getHours() + 3);
  } else {
    if (moment(new Date()).format("Z") == "-03:00") {
      data.setHours(data.getHours() + 1);
    }
  }

  return moment(data).format(formato);
}

export function getDataBanco(data) {
  if (data) {
    return `${data.split("/")[2]}/${data.split("/")[1]}/${data.split("/")[0]}`;
  } else {
    return null;
  }
}

export function getDataHoraBanco(dataHora) {
  if (dataHora) {
    let data = `${dataHora.split(" ")[0].split("/")[2]}/${
      dataHora.split(" ")[0].split("/")[1]
    }/${dataHora.split(" ")[0].split("/")[0]}`;
    let hora = dataHora.split(" ")[1];

    return `${data} ${hora}`;
  } else {
    return null;
  }
}

/**
 * Converte uma competência no formato de exibição "MM/YYYY" para o formato de armazenamento "YYYYMM".
 *
 * Aceita valores nulos/indefinidos e strings; valida se o mês está entre "01" e "12" e o ano tem 4 dígitos.
 *
 * @param {string|null|undefined} valor - Competência no formato "MM/YYYY" (ex.: "01/2024").
 * @returns {string|null} A competência no formato "YYYYMM" (ex.: "202401") quando a entrada for válida; caso contrário, retorna null.
 *
 * @example
 * // retorna "202312"
 * transformarCompetenciaTelaParaCompetenciaBD("12/2023");
 *
 * @example
 * // retorna null (formato inválido)
 * transformarCompetenciaTelaParaCompetenciaBD("2023-12");
 */
export function transformarCompetenciaTelaParaCompetenciaBD(valor) {
    const match = (valor || "").match(/^(0[1-9]|1[0-2])\/(\d{4})$/);
    return match ? `${match[2]}${match[1]}` : null;
};